import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import {
  Button,
  IconSuccess,
  Preview,
  PreviewBody,
  PreviewButton,
  PreviewFoot,
  PreviewHead,
  PreviewItem
} from "../../components/weui";
import { userService } from "../../services";
import { refreshMeters, selectMeters } from "../../stores";
import { formatDateTime, getAxiosError } from "../../utils";

export const MeterList = () => {
  const meters = useSelector(selectMeters);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleUnbind = useCallback(m => {
    weui.confirm(`${m.meterClass} ${m.meterNo}`,
      async () => {
        try {
          await userService.unbindMeter(m.meterNo);
          dispatch(refreshMeters());
        } catch(err) {
          weui.alert(getAxiosError(err), {
            title: "解绑表计失败"
          });
        }
      }, {
        title: "确定要解绑此表计吗?"
      });
  }, [dispatch]);

  const handleDefault = useCallback(async m => {
    try {
      await userService.setDefaultMeter(m.meterNo);
      dispatch(refreshMeters());
    } catch(err) {
      weui.alert(getAxiosError(err), {
        title: "设置默认表计失败"
      });
    }
  }, [dispatch]);

  const renderMeter = m => {
    return <Preview key={ m.meterNo } className="mb-5">
      <PreviewHead>
        <PreviewItem label="显示名称">
          { m.name }
          { m.isDefault && <IconSuccess className="ml-2" /> }
        </PreviewItem>
      </PreviewHead>
      <PreviewBody>
        <PreviewItem label="表计编号">{ m.meterNo }</PreviewItem>
        <PreviewItem label="表计类别">
          { m.meterClass }
        </PreviewItem>
        <PreviewItem label="所属区域">{ m.corpName }</PreviewItem>
        <PreviewItem label="绑定时间">
          { formatDateTime(new Date(m.bindingTime)) }
        </PreviewItem>
      </PreviewBody>
      <PreviewFoot>
        <PreviewButton onClick={ e => handleUnbind(m) }>解绑</PreviewButton>
        <PreviewButton
          className={ { "hidden": m.isDefault } }
          onClick={ e => handleDefault(m) }
          primary>设为默认</PreviewButton>
      </PreviewFoot>
    </Preview>;
  };

  return (
    <>
      { meters.map(m => renderMeter(m)) }

      <Button className="mt-10" type="primary" onClick={ e => navigate("/me/meters/binding") }>添加表计</Button>
    </>
  );
};
